<template>
	<el-card shadow="never" class="l-main-card">
		<div class="l-table-toolbar">
			<l-auth-button type="primary" auth="resource_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
			<div class="l-simple-search-container">
				<el-input placeholder="请输入资源名称" v-model="search_data.name" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
				</el-input>

				<div class="l-show-more-search" @click="search_visible = true">
					<i class="ri-align-center"></i>
					<span>高级搜索</span>
				</div>
			</div>
		</div>
		<l-table :data="data" v-loading="loading" row-key="id">
			<el-table-column fixed prop="index" label="序号" width="150"> </el-table-column>
			<el-table-column prop="name" label="资源名称" min-width="200"> </el-table-column>
			<el-table-column prop="identify" label="资源标识" min-width="200"> </el-table-column>
			<el-table-column prop="type" label="类型" width="120">
				<template slot-scope="{ row }">
					{{ TYPE_NAMES[row.type] }}
				</template>
			</el-table-column>
			<el-table-column prop="state" label="状态" width="120">
				<template slot-scope="{ row }">
					<el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" @click="() => changeState(row)" disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="is_public" label="是否公共资源" width="120">
				<template slot-scope="{ row }">
					{{ IS_PUBLIC_NAMES[row.is_public] }}
				</template>
			</el-table-column>
			<el-table-column prop="use_type" label="使用场景" width="120">
				<template slot-scope="{ row }">
					<span v-show="row.use_type == 1">PC后台</span>
					<span v-show="row.use_type == 2">小程序</span>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" width="180"> </el-table-column>
			<el-table-column prop="update_time" label="修改时间" width="180"> </el-table-column>

			<el-table-column fixed="right" label="操作" width="150" align="center">
				<template slot-scope="{ row }">
					<l-auth-text-button type="primary" auth="resource_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
					<span class="l-action-separator">|</span>
					<l-auth-text-button type="danger" auth="resource_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
				</template>
			</el-table-column>
		</l-table>

		<!--分页-->
		<l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

		<!--添加-->
		<l-dialog :visible.sync="add_visible" title="添加资源">
			<l-resources-edit @on-success="onAddSucess" :visible.sync="add_visible"></l-resources-edit>
		</l-dialog>

		<!--编辑-->
		<l-dialog :visible.sync="edit_visible" title="编辑资源">
			<l-resources-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-resources-edit>
		</l-dialog>

		<!--高级搜索-->
		<el-drawer title="高级搜索" class="l-search-drawer" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
			<div class="l-search-drawer-body">
				<el-form label-width="80px" ref="search_form" :model="search_data">
					<el-form-item label="资源名称" prop="name">
						<el-input v-model="search_data.name" placeholder="资源名称"></el-input>
					</el-form-item>
					<el-form-item label="资源标识" prop="identify">
						<el-input v-model="search_data.identify" placeholder="资源名称"></el-input>
					</el-form-item>
					<el-form-item label="公共资源" prop="is_public">
						<el-select v-model="search_data.is_public" placeholder="请选择是否公共" clearable>
							<el-option v-for="(item, index) in IS_PUBLIC_NAMES" :key="index" :label="item" :value="index"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="资源类型" prop="type">
						<el-select v-model="search_data.type" placeholder="请选择资源类型" clearable>
							<el-option v-for="(item, index) in TYPE_NAMES" :key="index" :label="item" :value="index"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<div class="l-search-drawer-footer">
				<el-button type="normal" @click="onReset">重置</el-button>
				<el-button type="primary" @click="onSearch">搜索</el-button>
			</div>
		</el-drawer>
	</el-card>
</template>

<script>
import { METHOD_NAMES, STATES, STATE_NAMES, TYPE_NAMES, IS_PUBLIC_NAMES } from "@/common/constants/resources";
import Edit from "./Edit";
import Vue from "vue";
export default {
	components: {
		[Edit.name]: Edit,
	},
	data() {
		return {
			data: [],
			count: 0,
			page: 1,
			page_size: Vue.$_config.page.page_size,
			loading: false,
			change_state_loading: [],

			add_visible: false, //是否显示添加

			edit_visible: false, //是否显示编辑
			edit_id: 0,

			TYPE_NAMES: TYPE_NAMES,
			METHOD_NAMES: METHOD_NAMES,
			IS_PUBLIC_NAMES: IS_PUBLIC_NAMES,
			STATES: STATES,
			STATE_NAMES: STATE_NAMES,

			//搜索
			search_visible: false,
			search_data: {
				name: "",
				identify: "",
				type: "",
				method: "",
				is_public: "",
			},
			rel_search_data: {},
			show_more_search: false,
		};
	},

	mounted() {
		this.getList();
	},

	methods: {
		//获取数据
		getList() {
			this.loading = true;
			this.$_invoke("resource_getList", {
				page: this.page,
				page_size: this.page_size,
				...this.rel_search_data,
			})
				.then((ret) => {
					this.data = ret.data;
					this.count = ret.count;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		//点击搜索按钮
		onSearch() {
			this.page = 1;
			this.rel_search_data = this.search_data;
			this.getList();
		},

		//点击重置搜索框
		onReset() {
			this.$refs.search_form.resetFields();
			this.rel_search_data = {};
		},

		//页码改变
		pageChange(page) {
			this.page = page;
			this.getList();
		},

		//每页显示条数改变
		pageSizeChange(page_size) {
			this.page_size = page_size;
			this.getList();
		},

		//修改状态
		changeState(row) {
			this.change_state_loading.push(row.id);
			this.$_invoke(`resource_updState`, {
				id: row.id,
				state: row.state,
			})
				.then((ret) => {
					row.state = ret.state;
					this.$_msg.success("修改状态成功");
				})
				
				.finally(() => {
					this.change_state_loading = this.change_state_loading.filter((item) => {
						return item != row.id;
					});
				});
		},

		//添加成功回调
		onAddSucess() {
			this.add_visible = false;
			this.getList();
		},

		//显示修改界面
		showEdit(id) {
			this.edit_id = id;
			this.$nextTick(() => {
				this.edit_visible = true;
			});
		},

		//编辑成功回调
		onEditSucess() {
			this.edit_visible = false;
			this.getList();
		},

		//显示修改密码界面
		showChangePwd(id) {
			this.change_pwd_id = id;
			this.$nextTick(() => {
				this.show_change_pwd = true;
			});
		},

		//修改密码成功回调
		onChangePwdSuccess() {
			this.show_change_pwd = false;
		},

		//删除
		del(id) {
			this.$confirm("确定删除该条记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$_invoke(`resource_delete`, { id }).then(() => {
						this.$_msg.success("删除成功");
						this.getList();
					});
				})
				.catch(() => {});
		},
	},
};
</script>
